module.exports = __webpack_public_path__ + "static/media/profileuser.75a55b0d.svg";